import { BasePolypizzaAsset } from "./base";
import { PolypizzaAsset } from "../types";
import { MediaType } from "../../../types";
import { IAssetMetadata } from "../..";
import { getBlobDataFromUrl } from "../../../utils";

export class Model3DAsset extends BasePolypizzaAsset {
  constructor(file: PolypizzaAsset) {
    super(file);
  }

  getMediaType() {
    return MediaType.Model3D;
  }

  getDownloadUrl(): string {
    return this.asset.Download;
  }

  getFilenameWithExtension(): string {
    const urlParts = this.getDownloadUrl().split('/');
    const extension = urlParts[urlParts.length - 1]?.split('.').pop();
    return `${this.getName()}.${extension}`;
  }

  async downloadFile(): Promise<{ blob: Blob, filename: string }> {
    const filename = this.getFilenameWithExtension();
    const { blob } = await getBlobDataFromUrl(this.getDownloadUrl());
    return { blob, filename };
  }

  getMetadata(): IAssetMetadata {
    return {
      status: 'ready',
      date: '',
      size: 0,
      categories: this.asset.Category,
      tags: this.asset.Tags,
      licence: this.asset.Licence,
      author: this.asset.Creator.Username,
      animations: this.asset.Animated,
    };
  }
}
